import { isClientOrUser } from "../utils/redirectHandler";
import { useAuthStore } from "../stores/authStore";

export function useB2CAuth(isTokenValid: boolean = false) {
  const authStore = useAuthStore();

  async function setupToken() {
    const token = await globalThis.msalAuth.getAccessToken();

    authStore.setToken(token, isTokenValid);
  }

  async function checkAuth() {
    if (isClientOrUser() === "clients") {
      const userLogin = authStore.user;
      if (userLogin) {
        authStore.isAuthenticatedB2C = true;
        setupToken();
        return;
      }
    } else {
      const userADLogin = authStore.userAD;
      if (userADLogin) {
        authStore.isAuthenticatedAD = true;
        setupToken();
        return;
      }
    }
  }

  async function handleAuthChange(event: Event) {
    const customEvent = event as CustomEvent;
    if (customEvent.detail.account) {
      await setupToken();
    }
  }

  async function initB2CAuth() {
    // Verificar autenticación inmediatamente
    await checkAuth();

    // Escuchar cambios de autenticación B2C
    window.addEventListener("msal:user-authenticated", handleAuthChange);

    // Retornar función de cleanup
    return () => {
      window.removeEventListener("msal:user-authenticated", handleAuthChange);
    };
  }

  return {
    initB2CAuth,
  };
}
